import { useEffect } from "react";
import { useState } from "react";

import { CustomDatePicker } from "../../../CustomDatePicker/CustomDatePicker";

//A prefiltered range arrives as a date string; an unset range arrives as year 1 from the server.
//A bare YYYY-MM-DD is read as UTC by the Date constructor, so it gets a time to keep it on the local day.
const prefilledDate = (value) => {
    if (!value) return null;
    const date = new Date(/^\d{4}-\d{2}-\d{2}$/.test(value) ? `${value}T00:00:00` : value);
    return isNaN(date.getTime()) || date.getFullYear() <= 1 ? null : date;
};

//Year 1 is what the server reads as an open bound. Sent without a timezone so it cannot underflow DateTime.
const UNSET_DATE = "0001-01-01T00:00:00";

//A bound the visitor cleared arrives as an empty string from the URL. That has to stay open, where a bound that
//was never in the URL falls back to the default range every date filter on the site starts with.
const CLEARED_BOUND = "";

const initialBound = (value, fallback) =>
    value === CLEARED_BOUND ? null : prefilledDate(value) ?? fallback();

//A date filter compares calendar days, so the picked day is sent as-is instead of as a UTC timestamp:
//serializing a Date would shift it to the previous day for any positive UTC offset.
export const toDateParam = (date) => {
    if (!date) return UNSET_DATE;
    const pad = (part) => String(part).padStart(2, "0");
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
};

//The range a visitor gets without touching anything. Exported so publishing the filter state to the URL can
//leave it out: an untouched range means the recipient of a copied link lands on the same default anyway.
export const defaultDateRange = () => {
    const from = new Date();
    const to = new Date();
    to.setFullYear(to.getFullYear() + 1);
    return { from: toDateParam(from), to: toDateParam(to) };
};

export const FilterDate = (props) => {

    const [startDate, setStartDate] = useState(
        () => initialBound(props.filter.dateStartValue, () => new Date()));
    const [endDate, setEndDate] = useState(() => initialBound(props.filter.dateEndValue, () => {
        const fallback = new Date();
        fallback.setFullYear(fallback.getFullYear() + 1);
        return fallback;
    }));

    //On date change, update state
    useEffect(() => {
        props.filter.dateStartValue = toDateParam(startDate);
        props.filter.dateEndValue = toDateParam(endDate);
        let newState = { ...props.ficheData };
        props.setFicheData(prev => {
            return {
                ...prev,
                filter: newState.filter
            }
        });
    }, [startDate, endDate]);

    return <div className={`date-filter col-sm-${props.filter.gridWidth != 0 ? props.filter.gridWidth : 6}`}>
        <div className="date-filter-inner">
            <div className="date-filter-part">
                <label>
                    <strong>
                        {props.filter?.titleFrom || props.dictionary.from}
                    </strong>
                </label>
                <CustomDatePicker date={startDate} setDate={setStartDate} />
            </div>
            <div className="date-filter-part">
                <label>
                    <strong>
                        {props.filter?.titleUntil || props.dictionary.until}
                    </strong>
                </label>
                <CustomDatePicker date={endDate} setDate={setEndDate} />
            </div>
        </div>
    </div>;
}